import { render, staticRenderFns } from "./AudioListener.vue?vue&type=template&id=63e4b980&"
import script from "./AudioListener.vue?vue&type=script&lang=js&"
export * from "./AudioListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports